import bridge from '../core';

const apiName = 'setRightButtonVisible';
/**
 */

function fallback() {
    console.log('setRightButtonVisible: 调用原生失败');
}

function back(data) {
    return {
        api: data,
        fallback
    };
}
bridge.register(apiName, back);
